import { Button, Text, YStack } from '@frontend/web-react';

type StripeUnavailableCopy = {
  actionLabel: string;
  description: string;
};

const RETRY_COPY: StripeUnavailableCopy = {
  actionLabel: 'Try again',
  description: 'An ad blocker or privacy setting is probably in the way. Disable it for this page, then try again.',
};

const RELOAD_COPY: StripeUnavailableCopy = {
  actionLabel: 'Refresh the page',
  description:
    'A refresh should bring it back up. If it keeps happening, an ad blocker or privacy setting may be the culprit.',
};

type StripeUnavailableProps = {
  onAction: () => void;
  reloadCopy?: StripeUnavailableCopy;
  retryCopy?: StripeUnavailableCopy;
  variant?: 'reload' | 'retry';
};

export const StripeUnavailable = ({
  onAction,
  reloadCopy = RELOAD_COPY,
  retryCopy = RETRY_COPY,
  variant = 'retry',
}: StripeUnavailableProps) => {
  const { actionLabel, description } = variant === 'reload' ? reloadCopy : retryCopy;
  return (
    <YStack gapY="md" p="md">
      <Text type="h4">Checkout took a duck dive.</Text>
      <Text color="secondary" type="p-sm">
        {description}
      </Text>
      <Button label={actionLabel} onClick={onAction} />
    </YStack>
  );
};
